import ApiProvider from './ApiProvider';
import { ActionStatusType } from '../types/ActionStatusType';

const ApplicationSettingsApi = {
  getApplicationSettings: async () => {
    return await ApiProvider.get<ActionStatusType>('Configuration/getAppSettings');
  },
};

export default ApplicationSettingsApi;
